import React, { useState } from 'react';
import styles from './Setting.module.css';

import { FaEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa6";
import { IoSettings } from "react-icons/io5";
import { FaUser } from "react-icons/fa";

const Setting = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [profile, setProfile] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    image: null,
  });
  const [passwords, setPasswords] = useState({
    current: '',
    new: '',
    confirm: '',
  });
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const handleProfileChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfile({ ...profile, image: URL.createObjectURL(file) });
    }
  };

  const handleImageRemove = () => {
    setProfile({ ...profile, image: null });
  };

  const handlePasswordChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const toggleShowPassword = (field) => {
    setShowPassword({ ...showPassword, [field]: !showPassword[field] });
  };

  return (
    <div className={styles.container}>
    <div className={styles.containerHead}>
    <IoSettings />
    <h2 className={styles.title}>General settings</h2>
    </div>
      <div className={styles.wrapper}>
        <aside className={styles.sidebar}>
          <button
            className={activeTab === 'profile' ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab('profile')}
          >
            Profile setting
          </button>
          <button
            className={activeTab === 'password' ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab('password')}
          >
            Change password
          </button>
        </aside>

        <section className={styles.profileSection}>
          {activeTab === 'profile' && (
            <>
              <h3 className={styles.profileTitle}>Profile setting</h3>
              <div className={styles.imageUpload}>
               {profile.image ? (
                <img
                  src={profile.image || 'https://via.placeholder.com/60'}
                  alt="Profile"
                  className={styles.avatar}
                />
               ):(
                <div className={styles.avatar}>
          
                <FaUser />
                </div>
               )}
                <div>
                  <p className={styles.label}>Profile Picture</p>

                  <input
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={handleImageUpload}
                  />
                                    <p className={styles.subtext}>Image support: png, jpeg (under 10MB)</p>
                </div>
              </div>

              <div className={styles.form}>
             <div className={styles.formInput}>
             <label>Name</label>
                <input
                  type="text"
                  name="firstName"
                  // placeholder="First name"
                  value={profile.firstName}
                  onChange={handleProfileChange}
                />
             </div>
               <div className={styles.formInput}>
               <label>Email Id</label>
                <input
                  type="email"
                  name="email"
                  // placeholder="Email Id"
                  value={profile.email}
                  onChange={handleProfileChange}
                />
               </div>
                 {/* <div className={styles.formInput}>
                 <lable>First name</lable>
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone no."
                  value={profile.phone}
                  onChange={handleProfileChange}
                />
                 </div> */}
              </div>
            </>
          )}

          {activeTab === 'password' && (
            <>
              <h3 className={styles.profileTitle}>Change Password</h3>
              <div className={styles.formPassword}>
                {['current', 'new', 'confirm'].map((field, idx) => (
                  <div key={idx} className={styles.passwordField}>
                    <label>
                      {field === 'current' && 'Current Password'}
                      {field === 'new' && 'New Password'}
                      {field === 'confirm' && 'Confirm Password'}
                    </label>
                    <div className={styles.passwordInputWrapper}>
                      <input
                        type={showPassword[field] ? 'text' : 'password'}
                        name={field}
                        placeholder=""
                        value={passwords[field]}
                        onChange={handlePasswordChange}
                      />
                      <button
                        type="button"
                        className={styles.eyeBtn}
                        onClick={() => toggleShowPassword(field)}
                      >
                        {showPassword[field] ? <FaRegEyeSlash size={16} /> : <FaEye size={16} />}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className={styles.actions}>
            <button className={styles.cancel}>Cancel</button>
            <button className={styles.save}>Save</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Setting;
